import { memo } from 'react';

import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import PropTypes from 'prop-types';

const AppCard = memo(function AppCard({
  title,
  subheader,
  action,
  children,
  footer,
  elevation = 0,
  variant = 'outlined',
  ...rest
}) {
  return (
    <Card elevation={elevation} variant={variant} {...rest}>
      {(title || subheader || action) && (
        <CardHeader title={title} subheader={subheader} action={action} />
      )}
      <CardContent>{children}</CardContent>
      {footer ? <CardActions>{footer}</CardActions> : null}
    </Card>
  );
});

AppCard.propTypes = {
  title: PropTypes.node,
  subheader: PropTypes.node,
  action: PropTypes.node,
  children: PropTypes.node,
  footer: PropTypes.node,
  elevation: PropTypes.number,
  variant: PropTypes.oneOf(['elevation', 'outlined']),
};

export default AppCard;
